import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, Button, SkeletonText } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom";

import DeleteIcon from "@/assets/DeleteIcon";
import EditIcon from "@/assets/EditIcon";
import InactiveStatus from "@/assets/InactiveStatus";
import ActiveStatus from "@/assets/ActiveStatus";
import countries from "@/data/countries";
import FileIcon from "@/assets/FileIcon";
import ButtonReview from "@/assets/ButtonReview";
import NewIcon from "@/assets/NewIcon";
import RejectIcon from "@/assets/RejectIcon";
import InReviewIcon from "@/assets/InReviewIcon";
import Pagination from "../Layouts/Pagination";
import { COLORS } from "@/common/constants";

const TableShipOwner = ({
    dataList,
    isLoading,
    handleEdit,
    handleDelete,
    currentPageSize,
    handleChangePageSize,
    handleChangePageNumber,
    currentPageNumber,
    totalPageNumber,
    hasNextPage,
    handleDownload,
    handleReview
}: any) => {

    const navigate = useNavigate();

    const handleVessel = (idShipOwner: string) => {
        navigate('/manage-ship-operator/vessel', {
            state: { idShipOwner, currentPageNumberList: currentPageNumber, currentPageSizeList: currentPageSize }
        });
    }

    const handleAddVessel = (idShipOwner: string, onBehalfCompany: string) => {
        navigate('/manage-ship-operator/vessel/add', {
            state: { idShipOwner, onBehalfCompany, type: 'add' }
        });
    }

    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Company Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Country</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Contact Person</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Email</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Vessel</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>DOC File</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Status</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Action</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        {isLoading && (
                            <Tr>
                                <Td colSpan={8}>
                                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                                </Td>
                            </Tr>
                        )}

                        {!isLoading && (!dataList || dataList.length === 0) && (
                            <Tr>
                                <Td colSpan={8} textAlign="center">Data not found</Td>
                            </Tr>
                        )}

                        {!isLoading && dataList?.map((item: any) => {
                            return (
                                <Tr
                                    key={item.id}
                                    bgColor={
                                        (item.existNewVessel || item.vessels.length === 0)
                                            ? "pink.200"
                                            : "transparent"
                                    }
                                >
                                    <Td>{item.onBehalfCompany}</Td>
                                    <Td>{countries?.find((x: any) => x.value === item.country)?.label || "-"}</Td>
                                    <Td>{item.contactPerson}</Td>
                                    <Td>{item.email}</Td>

                                    <Td textAlign='center'>
                                        {item.vessels.length > 0 ? (
                                            <Button
                                                bgColor="#079455"
                                                borderRadius='full'
                                                color='white'
                                                height='25px'
                                                onClick={() => handleVessel(item.id)}
                                            >
                                                {item.vessels.length} - Detail
                                            </Button>
                                        ) : (
                                            <Button
                                                bgColor="#079455"
                                                borderRadius='full'
                                                color='white'
                                                height='25px'
                                                onClick={() => handleAddVessel(item.id, item.onBehalfCompany)}
                                            >
                                                Add New
                                            </Button>
                                        )}
                                    </Td>

                                    <Td style={{ display: 'flex', cursor: 'pointer', gap: 8, justifyContent: 'center' }}>
                                        {item.documents ? (
                                            <FileIcon
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleDownload(item.documents, 0)}
                                            />
                                        ) : (
                                            <p>-</p>
                                        )}
                                    </Td>

                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.status === 0 && <p>-</p>}
                                            {item.status === 1 && <NewIcon />}
                                            {item.status === 2 && <InReviewIcon />}
                                            {item.status === 3 && <ActiveStatus />}
                                            {item.status === 4 && <RejectIcon />}
                                            {item.status === 5 && <InactiveStatus />}
                                        </div>
                                    </Td>

                                    <Td style={{
                                        display: 'flex',
                                        cursor: 'pointer',
                                        gap: 8,
                                        justifyContent: 'center',
                                        paddingTop: '10px',
                                        paddingBottom: '10px'
                                    }}>
                                        {item.status === 0 && <p>-</p>}
                                        {(item.status === 1 || item.status === 2 || item.status === 4) && (
                                            <ButtonReview onClick={() => handleReview(item.id)} />
                                        )}
                                        {(item.status === 3 || item.status === 5) && (
                                            <>
                                                <EditIcon onClick={() => handleEdit(item.id)} />
                                                <DeleteIcon onClick={() => handleDelete(item.id)} />
                                            </>
                                        )}
                                        {(item.status === 4) && (
                                            <>
                                                <DeleteIcon onClick={() => handleDelete(item.id)} />
                                            </>
                                        )}
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </Box>

            <Pagination
                currentPageSize={currentPageSize}
                currentPageNumber={currentPageNumber}
                totalPageNumber={totalPageNumber}
                handleChangePageSize={handleChangePageSize}
                handleChangePageNumber={handleChangePageNumber}
                hasNextPage={hasNextPage}
            />
        </TableContainer>
    )
}

export default TableShipOwner;
